import React, { useEffect, useState, useRef } from "react"
import { Polar } from "react-chartjs-2"
import { FaDownload } from "react-icons/fa"
import API from "../../api"
// eslint-disable-next-line react/prop-types
const StatsPolarChart = ({ width = 300, height = 300 }) => {
  const chartRef = useRef(null)
  const [chartData, setChartData] = useState(null)
  var userAuthScolarite = JSON.parse(localStorage.getItem("userAuthScolarite"))
  var annee_id = userAuthScolarite.user.annee_id
  useEffect(() => {
     API.post("fiche/count_fiche",{annee_id,semestre_id:1})
      .then((res) => {
        const data = res.data.data
        const formattedData = {
          labels: [
            "Fiches invalides",
            "Fiches valides",
            "Enseignants sans fiches",
            "Enseignants avec fiches",
          ],
          datasets: [
            {
              label: "Statistiques des fiches",
              data: [
                data.fichesinvalides,
                data.fichesvalides,
                data.enseignantsSansFiches,
                data.enseignantsavecFiches,
              ],
              backgroundColor: [
                "rgba(255, 99, 132, 0.6)",
                "rgba(54, 162, 235, 0.6)",
                "rgba(255, 206, 86, 0.6)",
                "rgba(75, 192, 192, 0.6)",
              ],
              borderWidth: 1,
            },
          ],
        }

        setChartData(formattedData)
      })
      .catch((err) => {
        console.error("Erreur de chargement des statistiques :", err)
      })
  }, [])
  const options = {
    responsive: true,
    maintainAspectRatio: false,
    legend: {
      position: "bottom",
    },
  }
  const handleDownload = () => {
    const chartInstance = chartRef.current.chartInstance
    if (!chartInstance) return
    const url = chartInstance.toBase64Image()
    const link = document.createElement("a")
    link.href = url
    link.download = "polar_chart.png"
    link.click()
  }
  if (!chartData) {
    return <p style={{ textAlign: "center" }}>Chargement des statistiques...</p>
  }
  return (
    <div style={{ textAlign: "center" }}>
      <h3 style={{ color: "#FF6384" }}>Statistique de fiche pédagogique</h3>
      <FaDownload
        onClick={handleDownload}
        style={{
          cursor: "pointer",
          marginBottom: "10px",
          color: "#E91E63",
          fontSize: "17px",
        }}
      />
      <div style={{ width: width, height: height, margin: "0 auto" }}>
        <Polar ref={chartRef} data={chartData} options={options} />
      </div>
    </div>
  )
}

export default StatsPolarChart
